import dayjs from 'dayjs'
import Personnummer from 'personnummer'

export const getYearsOld = (birthDate: string) => {
  return dayjs().diff(birthDate, 'year')
}

export const getYearsOldFromSSN = (ssn: string) => {
  return Personnummer.valid(ssn) ? Personnummer.parse(ssn).getAge() : 0
}

export const extractDOB = (ssn: string) => {
  if (!Personnummer.valid(ssn)) {
    return ''
  }
  const date = Personnummer.parse(ssn).getDate()
  return dayjs(date).format('YYYY-MM-DD')
}

export const validateLegalAge = (ssn: string) => {
  const parsedSsn = Personnummer.parse(ssn)
  const birthDate = parsedSsn.getDate()
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }

  const minor = age < 18
  const child = age <= 13

  return { minor, child }
}
